import React from 'react';
import { Columns } from '@components/Columns';
import { JoyButtonTextPairing, BrowserButtonShapeImage, StyledLeftImageWrapper, BottomWave } from './JoyButtonSection.styles';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { useTranslation } from 'react-i18next';

export const JoyButtonSection: React.FC = () => {
  const { t } = useTranslation('babyRegistry');
  const joyButtonSectionData = t('joyButtonSection');

  return (
    <Box as="section" id="BabyRegistry_Joy_Button" paddingY={[8, 10]}>
      <Columns centered marginBottom={10}>
        <Columns.Column width={6}>
          <StyledLeftImageWrapper>
            <BrowserButtonShapeImage src="baby-registry/joy-button/etsy.jpg" optimization="default" />
          </StyledLeftImageWrapper>
        </Columns.Column>
        <Columns.Column width={4}>
          <Flex alignItems="center" css={{ height: '100%' }} justifyContent={['center', 'start']}>
            <JoyButtonTextPairing
              eyebrow={joyButtonSectionData.eyebrow}
              eyebrowColor="neutra4"
              eyebrowVariant="sectionEyeBrow20"
              eyebrowTagName="h2"
              title={joyButtonSectionData.title}
              titleVariant="hed40"
              titleColor="neutra6"
              titleTagName="h2"
              body={joyButtonSectionData.body}
              bodyVariant="featureCopy17"
              bodyColor="neutra5"
              bodyTagName="p"
            />
          </Flex>
        </Columns.Column>
      </Columns>
      <BottomWave src="baby-registry/joy-button/gold-thread-5.svg" optimization="default" />
    </Box>
  );
};
